import { TrainingReviewHome } from "@/components/training-simulator/review/training-review-home";
import { requirePermission } from "@/lib/casl/route-guards";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/training/review/")({
  component: TrainingReviewHome,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "training-simulator-reviews");
  },
});
